<kiene-heimtier-belege-table [kunde_id]="heimtierBeleg?.kunde_id"></kiene-heimtier-belege-table>
